import { EventNameType } from './formItem'
import {
  invoicingType,
  getStorageSelFn,
  orderTypeData,
  myLaunchState,
} from '../../tools/util'
import { getPlatformList } from '../../tools/util'
import {
  openInvoiceStateDict,
  accountStateList,
  accountStatusDict,
  brandCheckDict,
  convertDictToSearchList,
  extendedAttributeDict,
  fillingReportDict,
  paymentStatusDict,
  pictureRelevanceDict,
} from '../../tools/state'
import { orderStateEnum } from '../../global/enums'
import { materialTypeEnum } from '@/global/enum/product'
import { GlobalStorage } from '@/global/storage'
import { filterPermissionTypeFn } from '@/modules/goodsdetailmodules/util'
import {
  invoiceNatureEnum,
  paymentStatusEnum,
  titleOfTheContractEnum,
} from '@/global/enum/invoice'
import { signingTypeEnum } from '@/global/enum'
import {
  agreementSigningTypeEnum,
  agreementSignStatusEnum,
  agreementStatusEnum,
} from '@/global/enum/selfAgreement'
import {
  supplierInquiryItemStatusEnum,
  supplierInquiryStatusEnum,
} from '@/global/enum/inquiry'

export interface resultData {
  current: number
  total: number
  data: { code: string; name: string; id: string }[]
}
interface datasourceParam {
  id: string
  name: string
  code: string
  [x: string]: any
}

// 本地过滤数据
export const filterApiData = (
  params: datasourceParam[],
  filterStr?: string,
  page?: string,
): resultData => {
  const searchValue = filterStr ? filterStr.toLowerCase() : ''
  const arr = params.filter(
    (item: { name: string; code: string }) =>
      item?.name?.toLowerCase()?.includes(searchValue) ||
      item?.code?.toLowerCase()?.includes(searchValue),
  )
  const p = page ? Number.parseInt(page) : 1
  const startidnex = (p - 1) * 10
  const endindex = p * 10
  const slicedata = arr.slice(startidnex, endindex)
  if (page) {
    return {
      current: p,
      total: arr.length,
      data: slicedata,
    }
  }
  return {
    current: p,
    total: arr.length,
    data: arr,
  }
}
const fileStatusData = (page?: string, str?: string) => {
  const data = [
    { code: '1', name: '已上传', id: '1' },
    { code: '2', name: '未上传', id: '0' },
  ]
  return filterApiData(data, str, page)
}
const contractStatusData = (page?: string, str?: string) => {
  const data = [
    { code: '0', name: '关闭', id: '0' },
    { code: '1', name: '正常', id: '1' },
  ]
  return filterApiData(data, str, page)
}
const supplierLevelData = (page?: string, str?: string) => {
  const data = [
    { code: '1', name: '战略合作', id: '1' },
    { code: '2', name: '一般合作', id: '2' },
    { code: '3', name: '项目合作', id: '3' },
    { code: '4', name: '零星合作', id: '4' },
    { code: '5', name: '潜在合作', id: '5' },
    { code: '6', name: '电商类', id: '6' },
  ]
  return filterApiData(data, str, page)
}
const industryData = (page?: string, str?: string) => {
  const data = [
    { code: '1', name: '能源行业（电力、轨道、热电、风电）', id: '1' },
    { code: '2', name: '制造业', id: '2' },
    { code: '3', name: '采矿业', id: '3' },
    { code: '4', name: '建筑业', id: '4' },
    { code: '5', name: '信息传输、计算机服务和软件业', id: '5' },
    { code: '6', name: '交通运输、仓储物流业', id: '6' },
    { code: '7', name: '科学研究和技术服务业', id: '7' },
    { code: '8', name: '租赁和商务服务业', id: '8' },
    { code: '9', name: '文化、体育和娱乐业', id: '9' },
    { code: '10', name: '教育业', id: '10' },
  ]
  return filterApiData(data, str, page)
}
const erpStatusData = (page?: string, str?: string) => {
  const data = [
    { code: '1', name: '协议未上传', id: '1' },
    { code: '2', name: '同步成功', id: '2' },
    { code: '3', name: '缺失ERP编码', id: '3' },
    { code: '4', name: '同步失败', id: '4' },
    { code: '5', name: '暂存', id: '5' },
  ]
  return filterApiData(data, str, page)
}
const frontDeskData = (page?: string, str?: string) => {
  const data = [
    { code: '1', name: '已开通', id: '1' },
    { code: '2', name: '未开通', id: '2' },
  ]
  return filterApiData(data, str, page)
}
const supplierNatureData = (page?: string, str?: string) => {
  const data = [
    { code: '1', name: '生产型', id: '1' },
    { code: '2', name: '服务型', id: '2' },
    { code: '3', name: '商贸型', id: '3' },
  ]
  return filterApiData(data, str, page)
}
const applyTypeData = (page?: string, str?: string) => {
  const data = [
    { code: '1', name: '注册申请', id: '1' },
    { code: '2', name: '修改申请', id: '2' },
  ]
  return filterApiData(data, str, page)
}
const manageTypeData = (page?: string, str?: string) => {
  const data = [
    { code: '1', name: '品牌方', id: '1' },
    { code: '2', name: '集货商', id: '2' },
  ]
  return filterApiData(data, str, page)
}
const checkStateData = (page?: string, str?: string) => {
  const data = myLaunchState.map((item) => ({
    code: item.value,
    name: item.name,
    id: item.value,
  }))
  return filterApiData(data, str, page)
}
const isPermissionData = (page?: string, str?: string) => {
  const data = [
    { code: '1', name: '已上传', id: '1' },
    { code: '2', name: '未上传', id: '2' },
  ]
  return filterApiData(data, str, page)
}

const authorizationTypeData = (page?: string, str?: string) => {
  const data = [
    { code: '1', name: '品牌授权', id: '1' },
    { code: '2', name: '公司授权', id: '2' },
  ]
  return filterApiData(data, str, page)
}
const ossConnData = (page?: string, str?: string) => {
  const data = [
    { code: '1', name: '已上传', id: '1' },
    { code: '0', name: '未上传', id: '0' },
  ]
  return filterApiData(data, str, page)
}
// 4.0.0 新增
// 订单履约模块
// const invoicingStateData=()
const invoicingStateData = (page?: string, str?: string) => {
  const data = [
    { code: '1', name: '已开票', id: '1' },
    { code: '2', name: '未开票', id: '2' },
  ]
  return filterApiData(data, str, page)
}

const platformData = (page?: string, str?: string) => {
  return filterApiData(getPlatformList(), str, page)
}

const returnTypeData = (page?: string, str?: string) => {
  const data = [
    { code: '1', name: '退货单', id: '1' },
    { code: '2', name: '取消单', id: '2' },
  ]
  return filterApiData(data, str, page)
}

export const fillingStateList = [
  { code: '1', name: '报备中', id: '1' },
  { code: '2', name: '已派单', id: '2' },
  // { code: '3', name: '已撤回', id: '3' },
  { code: '4', name: '审核中', id: '4' },
  { code: '5', name: '审核驳回', id: '5' },
  { code: '6', name: '已到期', id: '6' },
]
const fillingStateData = (page?: string, str?: string) => {
  return filterApiData(fillingStateList, str, page)
}

const accountStateData = (page?: string, str?: string) => {
  return filterApiData(accountStateList, str, page)
}
export const supplierDirectShipmentList = [
  { code: 'true', name: '是', id: '1' },
  { code: 'false', name: '否', id: '2' },
]
const supplierDirectShipmentData = (page?: string, str?: string) => {
  return filterApiData(supplierDirectShipmentList, str, page)
}
export const messageTypeDataList = [
  { code: '1', name: '接单通知', id: '1' },
  { code: '2', name: '催单通知', id: '2' },
  { code: '3', name: '退货通知', id: '3' },
  { code: '4', name: '取消通知', id: '4' },
  { code: '10', name: '国网调价审核结果', id: '10' },
  { code: '11', name: '询价单通知', id: '11' },
  { code: '14', name: '物料审核通知', id: '14' },
]
const messageTypeData = (page?: string, str?: string) => {
  return filterApiData(messageTypeDataList, str, page)
}
export const signVoucherDataList = [
  { code: '1', name: '审核中', id: '1' },
  { code: '2', name: '驳回', id: '2' },
  { code: '3', name: '已确认', id: '3' },
  { code: '4', name: '待上传', id: '4' },
]
const signVoucherData = (page?: string, str?: string) => {
  return filterApiData(signVoucherDataList, str, page)
}
export const customerPaybackList = [
  { code: '1', name: '未完成', id: '1' },
  { code: '2', name: '已完成', id: '2' },
]
const customerPaybackData = (page?: string, str?: string) => {
  return filterApiData(customerPaybackList, str, page)
}

const invoiceTypeData = (page?: string, str?: string) => {
  const data = invoicingType.map((item) => ({
    id: item.mapKey,
    name: item.name,
    code: item.mapKey,
  }))
  return filterApiData(data, str, page)
}

const accountOpenInvoiceStatusData = (page?: string, str?: string) => {
  const list = convertDictToSearchList(openInvoiceStateDict)
  return filterApiData(list, str, page)
}

const converDataFn = (dict: any) => {
  return (page?: string, str?: string) => {
    const list = convertDictToSearchList(dict)
    return filterApiData(list, str, page)
  }
}

// 我的发票状态
export const invoiceState = [
  { code: '1', name: '审核中', id: '1' },
  { code: '2', name: '暂存', id: '2' },
  { code: '3', name: '审核通过', id: '3' },
  { code: '4', name: '驳回', id: '4' },
]
const invoiceStateData = (page?: string, str?: string) => {
  return filterApiData(invoiceState, str, page)
}

// 源单类型
const orderSourceStateData = (page?: string, str?: string) => {
  return filterApiData(
    orderTypeData.map((item) => ({
      id: item.code,
      code: item.code,
      name: item.name,
    })),
    str,
    page,
  )
}

// 合同类型
const contractTypeData = (page?: string, str?: string) => {
  const data = [
    { code: '1', name: '框架合同', id: '1' },
    { code: '2', name: '普通合同', id: '2' },
  ]
  return filterApiData(data, str, page)
}

// 合同状态
const landingContractStatusData = (page?: string, str?: string) => {
  const data = [
    { code: '1', name: '生效', id: '1' },
    { code: '2', name: '失效', id: '2' },
    { code: '3', name: '无效', id: '3' },
  ]
  return filterApiData(data, str, page)
}

// 签章状态
const signatureStatusData = (page?: string, str?: string) => {
  const data = [
    { code: '1', name: '已签章', id: '1' },
    { code: '2', name: '未签章', id: '2' },
  ]
  return filterApiData(data, str, page)
}

// 签订方式
const signingTypeData = (page?: string, str?: string) => {
  const data = [
    { code: '1', name: '纸质合同', id: '1' },
    { code: '2', name: '电子合同', id: '2' },
  ]
  return filterApiData(data, str, page)
}
export const reportTypeData = (page?: string, str?: string) => {
  const data = [
    { code: 'NEW', name: '商品新增', id: '1' },
    { code: 'MODIFY', name: '商品修改', id: '2' },
    { code: 'SHELF_MODIFY', name: '商品上下架更新', id: '3' },
    { code: 'PRICE_MODIFY', name: '商品价格更新', id: '4' },
    { code: 'RELAUNCHED', name: '商品重推', id: '5' },
  ]
  return filterApiData(data, str, page)
}

// 询价单状态数据
const inquiryStatusData = (page?: string, str?: string) => {
  const data = [
    { code: 'WAITING_ORDER', name: '待接单', id: '0' },
    { code: 'WAITING_QUOTE', name: '待报价', id: '1' },
    { code: 'QUOTED', name: '已报价', id: '2' },
    { code: 'WAITING_REQUOTE', name: '待重新报价', id: '3' },
    { code: 'CANCELLED', name: '采购方取消', id: '4' },
  ]
  return filterApiData(data, str, page)
}

// 物料条数运算符数据
const materialCountLevelData = (page?: string, str?: string) => {
  const data = [
    { code: '0', name: '等于', id: '0' },
    { code: '1', name: '小于', id: '1' },
    { code: '2', name: '大于', id: '2' },
    // { code: '3', name: '不等于', id: '3' },
  ]
  return filterApiData(data, str, page)
}
// 询价明细状态数据
const inquiryItemStatusData = (page?: string, str?: string) => {
  const list = [
    { code: 'QUOTED', name: '已报价', id: 'QUOTED' },
    { code: 'DRAFT', name: '待报价', id: 'DRAFT' },
    { code: 'ABANDONED', name: '已放弃', id: 'ABANDONED' },
    { code: 'NOT_QUOTED', name: '无需报价', id: 'NOT_QUOTED' },
  ]
  return filterApiData(list, str, page)
}

// ========== 1.6.0 项目物料 - 客户平台状态下拉数据（接口字段 thirdOnShelf，枚举 1~5） ==========
const thirdOnShelfData = (page?: string, str?: string) => {
  const data = [
    { code: '1', name: '已上架', id: '1' },
    { code: '2', name: '已下架', id: '2' },
    { code: '3', name: '审核中', id: '3' },
    { code: '4', name: '已驳回', id: '4' },
    { code: '5', name: '已冻结', id: '5' },
  ]
  return filterApiData(data, str, page)
}

// ========== 1.6.0 项目物料 - 审核状态下拉数据 ==========
const pmAuditStatusData = (page?: string, str?: string) => {
  const data = [
    { code: 'PASS', name: '通过', id: 'PASS' },
    { code: 'REJECTED', name: '驳回', id: 'REJECTED' },
    { code: 'AUDITING', name: '审核中', id: 'AUDITING' },
  ]
  return filterApiData(data, str, page)
}

// ========== 1.6.0 项目物料 - 提报类型下拉数据 ==========
const pmReportTypeData = (page?: string, str?: string) => {
  const data = [
    { code: 'NEW', name: '新增', id: 'NEW' },
    { code: 'RE_PUSH', name: '重推', id: 'RE_PUSH' },
    { code: 'PRICE_CHANGE', name: '改价', id: 'PRICE_CHANGE' },
    { code: 'MODIFY_INFO', name: '修改信息', id: 'MODIFY_INFO' },
    { code: 'ON_OFF_SHELF', name: '上下架', id: 'ON_OFF_SHELF' },
  ]
  return filterApiData(data, str, page)
}

const supplierOrderTypeStateData = (page?: string, str?: string) => {
  const data = [
    { code: 'NB', name: '标准采购', id: 'NB' },
    { code: 'DB', name: '定向采购', id: 'DB' },
    { code: 'Z040', name: '寄售采购', id: 'Z040' },
  ]
  return filterApiData(data, str, page)
}

type dataType = {
  [x in EventNameType]?: (page?: string, str?: string) => resultData
}

export const getTemplateData = () => {
  const userInfo = GlobalStorage.getStorageSync('USER_INFO')
  const data: dataType = {
    // contractStatus:getorg,
    isFile: fileStatusData,
    enterpriseLevel: supplierLevelData,
    contractStatus: contractStatusData,
    industry: industryData,
    erpState: erpStatusData,
    state: frontDeskData,
    enterpriseNature: supplierNatureData,
    applyType: applyTypeData,
    checkState: checkStateData,
    manageType: manageTypeData,
    isPermission: isPermissionData,
    authorizationType: authorizationTypeData,
    ossConn: ossConnData,
    invoicingState: invoicingStateData,
    orderState: orderStateEnum.toSearchListFn(),
    platform: platformData,
    returnType: returnTypeData,
    fillingState: fillingStateData,
    accountState: accountStateData,
    supplierDirectShipment: supplierDirectShipmentData,
    messageType: messageTypeData,
    signVoucher: signVoucherData,
    customerPayback: customerPaybackData,
    invoiceType: invoiceTypeData,
    accountOpenInvoiceStatus: accountOpenInvoiceStatusData,
    accountStatus: converDataFn(accountStatusDict),
    paymentStatusEnum: paymentStatusEnum.toSearchListFn(),
    paymentStatus: converDataFn(paymentStatusDict),
    mainPicture: converDataFn(pictureRelevanceDict),
    detailsPicture: converDataFn(pictureRelevanceDict),
    extendedAttribute: converDataFn(extendedAttributeDict),
    // srmProductType: materialTypeEnum.toSearchListFn(),
    srmProductType: materialTypeEnum.toSearchListFn({
      filterFn: (item) => {
        return filterPermissionTypeFn(item, { userInfo })
      },
    }),
    // unitCode: getUnitData,
    unitCode: getStorageSelFn('SEL_UNIT'),
    platformCodes: getStorageSelFn('SEL_PLATFORM'),
    platformCode: getStorageSelFn('SEL_PLATFORM'),
    srmPlatformCodes: getStorageSelFn('SEL_SRMPLATFORM'),
    filingType: converDataFn(fillingReportDict),
    mpmState: converDataFn(brandCheckDict),
    invoiceState: invoiceStateData,
    orderSource: orderSourceStateData,
    supplierOpenInvoiceState: accountOpenInvoiceStatusData,
    contractType: contractTypeData,
    landingContractStatus: landingContractStatusData,
    signingType: signingTypeEnum.toSearchListFn(),
    signatureStatus: signatureStatusData,
    // 自营协议管理
    agreementSigningType: agreementSigningTypeEnum.toSearchListFn(),
    agreementSignStatus: agreementSignStatusEnum.toSearchListFn(),
    agreementStatus: agreementStatusEnum.toSearchListFn(),
    reportType: reportTypeData,
    invoiceNature: invoiceNatureEnum.toSearchListFn(),
    titleOfTheContract: titleOfTheContractEnum.toSearchListFn(),
    status: supplierInquiryStatusEnum.toSearchListFn({
      idKey: 'numValue',
      // nameKey:'label',
      // codeKey:"value"
    }),
    materialCountLevel: materialCountLevelData,
    itemStatus: inquiryItemStatusData,
    overdueType: overdueTypeData,
    // 1.6.0 项目物料
    thirdOnShelf: thirdOnShelfData,
    pmAuditStatus: pmAuditStatusData,
    pmReportType: pmReportTypeData,
    supplierOrderType: supplierOrderTypeStateData,
  }
  return data
}

export const overdueTypeData = (page?: string, str?: string) => {
  const data = [
    { code: '1', name: '发货超期', id: '1' },
    { code: '2', name: '妥投超期', id: '2' },
  ]
  return filterApiData(data, str, page)
}
import { EventNameType } from './formItem'
import {
  invoicingType,
  getStorageSelFn,
  orderTypeData,
  myLaunchState,
} from '../../tools/util'
import { getPlatformList } from '../../tools/util'
import {
  openInvoiceStateDict,
  accountStateList,
  accountStatusDict,
  brandCheckDict,
  convertDictToSearchList,
  extendedAttributeDict,
  fillingReportDict,
  paymentStatusDict,
  pictureRelevanceDict,
} from '../../tools/state'
import { orderStateEnum } from '../../global/enums'
import { materialTypeEnum } from '@/global/enum/product'
import { GlobalStorage } from '@/global/storage'
import { filterPermissionTypeFn } from '@/modules/goodsdetailmodules/util'
import {
  invoiceNatureEnum,
  paymentStatusEnum,
  titleOfTheContractEnum,
} from '@/global/enum/invoice'
import { signingTypeEnum } from '@/global/enum'
import {
  agreementSigningTypeEnum,
  agreementSignStatusEnum,
  agreementStatusEnum,
} from '@/global/enum/selfAgreement'
import {
  supplierInquiryItemStatusEnum,
  supplierInquiryStatusEnum,
} from '@/global/enum/inquiry'

export interface resultData {
  current: number
  total: number
  data: { code: string; name: string; id: string }[]
}
interface datasourceParam {
  id: string
  name: string
  code: string
  [x: string]: any
}

// 本地过滤数据
export const filterApiData = (
  params: datasourceParam[],
  filterStr?: string,
  page?: string,
): resultData => {
  const searchValue = filterStr ? filterStr.toLowerCase() : ''
  const arr = params.filter(
    (item: { name: string; code: string }) =>
      item?.name?.toLowerCase()?.includes(searchValue) ||
      item?.code?.toLowerCase()?.includes(searchValue),
  )
  const p = page ? Number.parseInt(page) : 1
  const startidnex = (p - 1) * 10
  const endindex = p * 10
  const slicedata = arr.slice(startidnex, endindex)
  if (page) {
    return {
      current: p,
      total: arr.length,
      data: slicedata,
    }
  }
  return {
    current: p,
    total: arr.length,
    data: arr,
  }
}
const fileStatusData = (page?: string, str?: string) => {
  const data = [
    { code: '1', name: '已上传', id: '1' },
    { code: '2', name: '未上传', id: '0' },
  ]
  return filterApiData(data, str, page)
}
const contractStatusData = (page?: string, str?: string) => {
  const data = [
    { code: '0', name: '关闭', id: '0' },
    { code: '1', name: '正常', id: '1' },
  ]
  return filterApiData(data, str, page)
}
const supplierLevelData = (page?: string, str?: string) => {
  const data = [
    { code: '1', name: '战略合作', id: '1' },
    { code: '2', name: '一般合作', id: '2' },
    { code: '3', name: '项目合作', id: '3' },
    { code: '4', name: '零星合作', id: '4' },
    { code: '5', name: '潜在合作', id: '5' },
    { code: '6', name: '电商类', id: '6' },
  ]
  return filterApiData(data, str, page)
}
const industryData = (page?: string, str?: string) => {
  const data = [
    { code: '1', name: '能源行业（电力、轨道、热电、风电）', id: '1' },
    { code: '2', name: '制造业', id: '2' },
    { code: '3', name: '采矿业', id: '3' },
    { code: '4', name: '建筑业', id: '4' },
    { code: '5', name: '信息传输、计算机服务和软件业', id: '5' },
    { code: '6', name: '交通运输、仓储物流业', id: '6' },
    { code: '7', name: '科学研究和技术服务业', id: '7' },
    { code: '8', name: '租赁和商务服务业', id: '8' },
    { code: '9', name: '文化、体育和娱乐业', id: '9' },
    { code: '10', name: '教育业', id: '10' },
  ]
  return filterApiData(data, str, page)
}
const erpStatusData = (page?: string, str?: string) => {
  const data = [
    { code: '1', name: '协议未上传', id: '1' },
    { code: '2', name: '同步成功', id: '2' },
    { code: '3', name: '缺失ERP编码', id: '3' },
    { code: '4', name: '同步失败', id: '4' },
    { code: '5', name: '暂存', id: '5' },
  ]
  return filterApiData(data, str, page)
}
const frontDeskData = (page?: string, str?: string) => {
  const data = [
    { code: '1', name: '已开通', id: '1' },
    { code: '2', name: '未开通', id: '2' },
  ]
  return filterApiData(data, str, page)
}
const supplierNatureData = (page?: string, str?: string) => {
  const data = [
    { code: '1', name: '生产型', id: '1' },
    { code: '2', name: '服务型', id: '2' },
    { code: '3', name: '商贸型', id: '3' },
  ]
  return filterApiData(data, str, page)
}
const applyTypeData = (page?: string, str?: string) => {
  const data = [
    { code: '1', name: '注册申请', id: '1' },
    { code: '2', name: '修改申请', id: '2' },
  ]
  return filterApiData(data, str, page)
}
const manageTypeData = (page?: string, str?: string) => {
  const data = [
    { code: '1', name: '品牌方', id: '1' },
    { code: '2', name: '集货商', id: '2' },
  ]
  return filterApiData(data, str, page)
}
const checkStateData = (page?: string, str?: string) => {
  const data = myLaunchState.map((item) => ({
    code: item.value,
    name: item.name,
    id: item.value,
  }))
  return filterApiData(data, str, page)
}
const isPermissionData = (page?: string, str?: string) => {
  const data = [
    { code: '1', name: '已上传', id: '1' },
    { code: '2', name: '未上传', id: '2' },
  ]
  return filterApiData(data, str, page)
}

const authorizationTypeData = (page?: string, str?: string) => {
  const data = [
    { code: '1', name: '品牌授权', id: '1' },
    { code: '2', name: '公司授权', id: '2' },
  ]
  return filterApiData(data, str, page)
}
const ossConnData = (page?: string, str?: string) => {
  const data = [
    { code: '1', name: '已上传', id: '1' },
    { code: '0', name: '未上传', id: '0' },
  ]
  return filterApiData(data, str, page)
}
// 4.0.0 新增
// 订单履约模块
// const invoicingStateData=()
const invoicingStateData = (page?: string, str?: string) => {
  const data = [
    { code: '1', name: '已开票', id: '1' },
    { code: '2', name: '未开票', id: '2' },
  ]
  return filterApiData(data, str, page)
}

const platformData = (page?: string, str?: string) => {
  return filterApiData(getPlatformList(), str, page)
}

const returnTypeData = (page?: string, str?: string) => {
  const data = [
    { code: '1', name: '退货单', id: '1' },
    { code: '2', name: '取消单', id: '2' },
  ]
  return filterApiData(data, str, page)
}

export const fillingStateList = [
  { code: '1', name: '报备中', id: '1' },
  { code: '2', name: '已派单', id: '2' },
  // { code: '3', name: '已撤回', id: '3' },
  { code: '4', name: '审核中', id: '4' },
  { code: '5', name: '审核驳回', id: '5' },
  { code: '6', name: '已到期', id: '6' },
]
const fillingStateData = (page?: string, str?: string) => {
  return filterApiData(fillingStateList, str, page)
}

const accountStateData = (page?: string, str?: string) => {
  return filterApiData(accountStateList, str, page)
}
export const supplierDirectShipmentList = [
  { code: 'true', name: '是', id: '1' },
  { code: 'false', name: '否', id: '2' },
]
const supplierDirectShipmentData = (page?: string, str?: string) => {
  return filterApiData(supplierDirectShipmentList, str, page)
}
export const messageTypeDataList = [
  { code: '1', name: '接单通知', id: '1' },
  { code: '2', name: '催单通知', id: '2' },
  { code: '3', name: '退货通知', id: '3' },
  { code: '4', name: '取消通知', id: '4' },
  { code: '10', name: '国网调价审核结果', id: '10' },
  { code: '11', name: '询价单通知', id: '11' },
  { code: '14', name: '物料审核通知', id: '14' },
]
const messageTypeData = (page?: string, str?: string) => {
  return filterApiData(messageTypeDataList, str, page)
}
export const signVoucherDataList = [
  { code: '1', name: '审核中', id: '1' },
  { code: '2', name: '驳回', id: '2' },
  { code: '3', name: '已确认', id: '3' },
  { code: '4', name: '待上传', id: '4' },
]
const signVoucherData = (page?: string, str?: string) => {
  return filterApiData(signVoucherDataList, str, page)
}
export const customerPaybackList = [
  { code: '1', name: '未完成', id: '1' },
  { code: '2', name: '已完成', id: '2' },
]
const customerPaybackData = (page?: string, str?: string) => {
  return filterApiData(customerPaybackList, str, page)
}

const invoiceTypeData = (page?: string, str?: string) => {
  const data = invoicingType.map((item) => ({
    id: item.mapKey,
    name: item.name,
    code: item.mapKey,
  }))
  return filterApiData(data, str, page)
}

const accountOpenInvoiceStatusData = (page?: string, str?: string) => {
  const list = convertDictToSearchList(openInvoiceStateDict)
  return filterApiData(list, str, page)
}

const converDataFn = (dict: any) => {
  return (page?: string, str?: string) => {
    const list = convertDictToSearchList(dict)
    return filterApiData(list, str, page)
  }
}

// 我的发票状态
export const invoiceState = [
  { code: '1', name: '审核中', id: '1' },
  { code: '2', name: '暂存', id: '2' },
  { code: '3', name: '审核通过', id: '3' },
  { code: '4', name: '驳回', id: '4' },
]
const invoiceStateData = (page?: string, str?: string) => {
  return filterApiData(invoiceState, str, page)
}

// 源单类型
const orderSourceStateData = (page?: string, str?: string) => {
  return filterApiData(
    orderTypeData.map((item) => ({
      id: item.code,
      code: item.code,
      name: item.name,
    })),
    str,
    page,
  )
}

// 合同类型
const contractTypeData = (page?: string, str?: string) => {
  const data = [
    { code: '1', name: '框架合同', id: '1' },
    { code: '2', name: '普通合同', id: '2' },
  ]
  return filterApiData(data, str, page)
}

// 合同状态
const landingContractStatusData = (page?: string, str?: string) => {
  const data = [
    { code: '1', name: '生效', id: '1' },
    { code: '2', name: '失效', id: '2' },
    { code: '3', name: '无效', id: '3' },
  ]
  return filterApiData(data, str, page)
}

// 签章状态
const signatureStatusData = (page?: string, str?: string) => {
  const data = [
    { code: '1', name: '已签章', id: '1' },
    { code: '2', name: '未签章', id: '2' },
  ]
  return filterApiData(data, str, page)
}

// 签订方式
const signingTypeData = (page?: string, str?: string) => {
  const data = [
    { code: '1', name: '纸质合同', id: '1' },
    { code: '2', name: '电子合同', id: '2' },
  ]
  return filterApiData(data, str, page)
}
export const reportTypeData = (page?: string, str?: string) => {
  const data = [
    { code: 'NEW', name: '商品新增', id: '1' },
    { code: 'MODIFY', name: '商品修改', id: '2' },
    { code: 'SHELF_MODIFY', name: '商品上下架更新', id: '3' },
    { code: 'PRICE_MODIFY', name: '商品价格更新', id: '4' },
    { code: 'RELAUNCHED', name: '商品重推', id: '5' },
  ]
  return filterApiData(data, str, page)
}

// 询价单状态数据
const inquiryStatusData = (page?: string, str?: string) => {
  const data = [
    { code: 'WAITING_ORDER', name: '待接单', id: '0' },
    { code: 'WAITING_QUOTE', name: '待报价', id: '1' },
    { code: 'QUOTED', name: '已报价', id: '2' },
    { code: 'WAITING_REQUOTE', name: '待重新报价', id: '3' },
    { code: 'CANCELLED', name: '采购方取消', id: '4' },
  ]
  return filterApiData(data, str, page)
}

// 物料条数运算符数据
const materialCountLevelData = (page?: string, str?: string) => {
  const data = [
    { code: '0', name: '等于', id: '0' },
    { code: '1', name: '小于', id: '1' },
    { code: '2', name: '大于', id: '2' },
    // { code: '3', name: '不等于', id: '3' },
  ]
  return filterApiData(data, str, page)
}
// 询价明细状态数据
const inquiryItemStatusData = (page?: string, str?: string) => {
  const list = [
    { code: 'QUOTED', name: '已报价', id: 'QUOTED' },
    { code: 'DRAFT', name: '待报价', id: 'DRAFT' },
    { code: 'ABANDONED', name: '已放弃', id: 'ABANDONED' },
    { code: 'NOT_QUOTED', name: '无需报价', id: 'NOT_QUOTED' },
  ]
  return filterApiData(list, str, page)
}

// ========== 1.6.0 项目物料 - 客户平台状态下拉数据（接口字段 thirdOnShelf，枚举 1~5） ==========
const thirdOnShelfData = (page?: string, str?: string) => {
  const data = [
    { code: '1', name: '已上架', id: '1' },
    { code: '2', name: '已下架', id: '2' },
    { code: '3', name: '审核中', id: '3' },
    { code: '4', name: '已驳回', id: '4' },
    { code: '5', name: '已冻结', id: '5' },
  ]
  return filterApiData(data, str, page)
}

// ========== 1.6.0 项目物料 - 审核状态下拉数据 ==========
const pmAuditStatusData = (page?: string, str?: string) => {
  const data = [
    { code: 'PASS', name: '通过', id: 'PASS' },
    { code: 'REJECTED', name: '驳回', id: 'REJECTED' },
    { code: 'AUDITING', name: '审核中', id: 'AUDITING' },
  ]
  return filterApiData(data, str, page)
}

// ========== 1.6.0 项目物料 - 提报类型下拉数据 ==========
const pmReportTypeData = (page?: string, str?: string) => {
  const data = [
    { code: 'NEW', name: '新增', id: 'NEW' },
    { code: 'RE_PUSH', name: '重推', id: 'RE_PUSH' },
    { code: 'PRICE_CHANGE', name: '改价', id: 'PRICE_CHANGE' },
    { code: 'MODIFY_INFO', name: '修改信息', id: 'MODIFY_INFO' },
    { code: 'ON_OFF_SHELF', name: '上下架', id: 'ON_OFF_SHELF' },
  ]
  return filterApiData(data, str, page)
}

const supplierOrderTypeStateData = (page?: string, str?: string) => {
  const data = [
    { code: 'NB', name: '标准采购', id: 'NB' },
    { code: 'DB', name: '定向采购', id: 'DB' },
    { code: 'Z040', name: '寄售采购', id: 'Z040' },
  ]
  return filterApiData(data, str, page)
}

type dataType = {
  [x in EventNameType]?: (page?: string, str?: string) => resultData
}

export const getTemplateData = () => {
  const userInfo = GlobalStorage.getStorageSync('USER_INFO')
  const data: dataType = {
    // contractStatus:getorg,
    isFile: fileStatusData,
    enterpriseLevel: supplierLevelData,
    contractStatus: contractStatusData,
    industry: industryData,
    erpState: erpStatusData,
    state: frontDeskData,
    enterpriseNature: supplierNatureData,
    applyType: applyTypeData,
    checkState: checkStateData,
    manageType: manageTypeData,
    isPermission: isPermissionData,
    authorizationType: authorizationTypeData,
    ossConn: ossConnData,
    invoicingState: invoicingStateData,
    orderState: orderStateEnum.toSearchListFn(),
    platform: platformData,
    returnType: returnTypeData,
    fillingState: fillingStateData,
    accountState: accountStateData,
    supplierDirectShipment: supplierDirectShipmentData,
    messageType: messageTypeData,
    signVoucher: signVoucherData,
    customerPayback: customerPaybackData,
    invoiceType: invoiceTypeData,
    accountOpenInvoiceStatus: accountOpenInvoiceStatusData,
    accountStatus: converDataFn(accountStatusDict),
    paymentStatusEnum: paymentStatusEnum.toSearchListFn(),
    paymentStatus: converDataFn(paymentStatusDict),
    mainPicture: converDataFn(pictureRelevanceDict),
    detailsPicture: converDataFn(pictureRelevanceDict),
    extendedAttribute: converDataFn(extendedAttributeDict),
    // srmProductType: materialTypeEnum.toSearchListFn(),
    srmProductType: materialTypeEnum.toSearchListFn({
      filterFn: (item) => {
        return filterPermissionTypeFn(item, { userInfo })
      },
    }),
    // unitCode: getUnitData,
    unitCode: getStorageSelFn('SEL_UNIT'),
    platformCodes: getStorageSelFn('SEL_PLATFORM'),
    platformCode: getStorageSelFn('SEL_PLATFORM'),
    srmPlatformCodes: getStorageSelFn('SEL_SRMPLATFORM'),
    filingType: converDataFn(fillingReportDict),
    mpmState: converDataFn(brandCheckDict),
    invoiceState: invoiceStateData,
    orderSource: orderSourceStateData,
    supplierOpenInvoiceState: accountOpenInvoiceStatusData,
    contractType: contractTypeData,
    landingContractStatus: landingContractStatusData,
    signingType: signingTypeEnum.toSearchListFn(),
    signatureStatus: signatureStatusData,
    // 自营协议管理
    agreementSigningType: agreementSigningTypeEnum.toSearchListFn(),
    agreementSignStatus: agreementSignStatusEnum.toSearchListFn(),
    agreementStatus: agreementStatusEnum.toSearchListFn(),
    reportType: reportTypeData,
    invoiceNature: invoiceNatureEnum.toSearchListFn(),
    titleOfTheContract: titleOfTheContractEnum.toSearchListFn(),
    status: supplierInquiryStatusEnum.toSearchListFn({
      idKey: 'numValue',
      // nameKey:'label',
      // codeKey:"value"
    }),
    materialCountLevel: materialCountLevelData,
    itemStatus: inquiryItemStatusData,
    overdueType: overdueTypeData,
    // 1.6.0 项目物料
    thirdOnShelf: thirdOnShelfData,
    pmAuditStatus: pmAuditStatusData,
    pmReportType: pmReportTypeData,
    supplierOrderType: supplierOrderTypeStateData,
  }
  return data
}

export const overdueTypeData = (page?: string, str?: string) => {
  const data = [
    { code: '1', name: '发货超期', id: '1' },
    { code: '2', name: '妥投超期', id: '2' },
  ]
  return filterApiData(data, str, page)
}
